const ALLOWED_IMAGE_MIME = ['image/png', 'image/jpeg'];
const ALLOWED_IMAGE_EXT = ['.png', '.jpg', '.jpeg'];
const PDF_MIME = 'application/pdf';
const PDF_EXT = '.pdf';

export function isAllowedUploadType(file: File, allowPdf: boolean): boolean {
  if (file.type) {
    if (ALLOWED_IMAGE_MIME.includes(file.type)) {
      return true;
    }
    if (allowPdf && file.type === PDF_MIME) {
      return true;
    }
    return false;
  }

  const name = file.name.toLowerCase();
  if (ALLOWED_IMAGE_EXT.some((ext) => name.endsWith(ext))) {
    return true;
  }
  if (allowPdf && name.endsWith(PDF_EXT)) {
    return true;
  }
  return false;
}
